import React from "react";
import { useCore } from "store/core";
import SelectReact from 'react-select'

const Multiselect = (props) => {
  const { form, field } = props;
  const { list } = useCore();
  const values = Array.isArray(field.value) ? field.value : [];
  const selectedItems = values.length > 0 && typeof values[0] === "object"
    ? list(values)
    : props.options.filter((item) => values.includes(item.value));


 const onChangeHandler=(items)=>{
  const selected = items || [];
   form.setFieldValue(
    field.name,
    selected.map((item) => item.value)
  );
 }

  return (
    <div className="text-xs col-span-2" style={{ zIndex: 9999 }}>
      <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <SelectReact placeholder="انتخاب..." value = {
             selectedItems
         }  onChange = {onChangeHandler} options={props.options}

         menuPortalTarget={document.body}
         styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} isClearable isMulti/>
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
};

export default Multiselect;
